type SocialImageCandidate = {
  croppedLogoUrl480?: string;
  croppedLogoUrl600?: string;
  croppedLogoUrl940?: string;
};

export function getSocialImageUrl(images?: SocialImageCandidate[]): string | undefined {
  return images
    ?.map((image) => image.croppedLogoUrl940 || image.croppedLogoUrl600 || image.croppedLogoUrl480)
    .find(Boolean);
}

/**
 * Extracts the canonical host from the event's API-supplied URL.
 * This is a trusted source (basicInfo.url from the event listing service)
 * as opposed to request headers which are attacker-controlled.
 */
export function resolveCanonicalHost(eventUrl: string): string {
  return new URL(eventUrl).host;
}

/*
 * Builds an absolute URL for og:image / twitter:image that goes through
 * the Next.js image optimizer. The optimizer fetches the source image
 * server-side, so the URL is safe from HTML-entity encoding issues that
 * affect Apple Mail's LinkPresentation (which fetches og:image verbatim
 * without decoding &amp; back to &).
 *
 * The host is derived from basicInfo.url (trusted API data), never from
 * unvalidated request headers.
 *
 * The basePath "/e" matches next.config.js for this app.
 */
export function buildSocialShareUrl(imageUrl: string, eventUrl: string): string {
  const host = resolveCanonicalHost(eventUrl);
  const encodedImage = encodeURIComponent(imageUrl);
  return `https://${host}/e/_next/image?url=${encodedImage}&w=940&q=75`;
}
